import { DisclaimerDTO } from '@/api/translation/dto/DisclaimerDTO'
import { Disclaimer } from '@/model/Disclaimer'

export class TranslationFactory {
  static fromDisclaimerDTO(dto: DisclaimerDTO): Disclaimer {
    return new Disclaimer(dto.link, dto.disclaimer)
  }
}
